export default function DiscountPercentage(price, discount) {
  const percentage = Math.round((discount / price) * 100);

  return percentage;
}